// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user,    setUser]    = useState(null);
    const [role,    setRole]    = useState(null);
    const [loading, setLoading] = useState(true); // ← wait before rendering

    // ── Restore session on every page load ────────────────────────────────────
    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                try {
                    const userSnap = await getDoc(doc(db, 'users', firebaseUser.uid));
                    const userData = userSnap.data();
                    const firestoreRole = userData?.role ?? 'user';

                    console.log('[AuthContext] Logged in:', firebaseUser.email, '| role:', firestoreRole);

                    setUser(firebaseUser);
                    setRole(firestoreRole);
                } catch (e) {
                    console.error('[AuthContext] Failed to fetch user role:', e);
                    setUser(firebaseUser);
                    setRole('user');
                }
            } else {
                setUser(null);
                setRole(null);
            }
            setLoading(false);
        });
        return () => unsub();
    }, []);

    // Called immediately after sign-in for instant UI update
    const login = (firebaseUser, firestoreRole) => {
        setUser(firebaseUser);
        setRole(firestoreRole);
    };

    const logout = () => {
        setUser(null);
        setRole(null);
    };

    // Don't render anything until auth state is resolved
    if (loading) return null;

    return (
        <AuthContext.Provider value={{ user, role, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);